// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"sc-x6CgHn5aGe12LAnkwV"};